import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { MyPageSettingsPageLayout } from '../features/my-page-settings/ui/my-page-settings-page-layout';
import { MyPageSettingsSecurityScreen } from '../features/my-page-settings/ui/my-page-settings-security-screen';

export function MyPageSecurityPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <MyPageSettingsPageLayout
      backAriaLabel={t('myPage.backAria')}
      frameDataUi="settings-security-frame"
      onBack={() => {
        navigate('/settings');
      }}
      onOpenHome={() => {
        navigate('/home');
      }}
      onOpenMyPage={() => {
        navigate('/my-page');
      }}
      pageDataUi="settings-security"
      title={t('myPageSettings.security.title')}
    >
      <MyPageSettingsSecurityScreen
        onOpenPin={() => {
          navigate('/settings/pin');
        }}
      />
    </MyPageSettingsPageLayout>
  );
}
